import moment from 'moment';
import { map } from 'lodash';
import { withRouter } from 'react-router';
import {
  compose,
  lifecycle,
  withState,
  withProps,
  branch,
  renderComponent,
  renderNothing,
} from 'recompose';

import { formatDuration } from '../../utils/helpers';
import Loader from '../../components/Loader';
import { getAppLinks, getShopAddress } from '../utils';
import { fetchCustomerWaitingList } from '../../confirmation/actions';

export default compose(
  withRouter,
  withState('busy', 'setBusy', true),
  withState('waitingList', 'setWaitingList', null),
  lifecycle({
    async componentDidMount() {
      try {
        const { customerWaitingListId } = this.props.params;
        const includes = ['shop', 'shop.address', 'shop.staticMap', 'customer', 'barber', 'services'];
        const waitingList = await fetchCustomerWaitingList(customerWaitingListId, includes);
        this.props.setWaitingList(waitingList);
      } finally {
        this.props.setBusy(false);
      }
    },
  }),
  branch(
    props => props.busy,
    renderComponent(Loader),
  ),
  branch(
    props => !props.waitingList,
    renderNothing,
  ),
  withProps(({ waitingList, params }) => {
    const { shop } = waitingList;
    return {
      shop,
      customer: waitingList.customer,
      barber: waitingList.barber,
      service: map(waitingList.services, 'name').join(', '),
      address: getShopAddress(shop),
      currentWaitingListPosition: waitingList.numberInLine,
      currentWaitingListPositionTitle: moment.localeData().ordinal(waitingList.numberInLine),
      duration: formatDuration(waitingList.serviceDuration),
      ...getAppLinks(params.brandRoute, ''),
      squireInfoClassName: shop.mobileAppCta ? 'c-phones-background__content' : 'u-mt-15',
    };
  }),
);



// WEBPACK FOOTER //
// ./src/app/notifications/hoc/withWaitingListNotification.js